import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { GlobalContext } from '../GlobalContext'
import Button from '../formfields/Button'
import HeaderDetails from '../shared-components/HeaderDetails'
import RedAlert from '../ui-elements/RedAlert'
import { table } from 'console'
import Spinner from '../ui-elements/Spinner'
import { subscribe } from '../utils/pubsub'
import { json } from 'stream/consumers'
import ChecklistSummary from '../dashboard/ChecklistSummary'
import YellowAlert from '../ui-elements/YellowAlert'
import Card from '../ui-elements/Card'
import CollapsableCheckPeriodSummary from './CollapsableCheckPeriodSummary'



type Props = {
}

function ProcessSummaryCheckPeriods({
}: Props) {

    const { processId } = useParams()
    const {
        tableData,
        sendMessageToWebsocket,
        setShowModal,
        processData,
        t
    } = useContext(GlobalContext)


    const thisProcessData = processId && processData && processData[processId]
    const inProgress = thisProcessData && thisProcessData.InProgress

    const pendingCheckPeriods = thisProcessData && thisProcessData.PendingCheckPeriods && thisProcessData.PendingCheckPeriods.sort((a: any, b: any) => {
        return b.StartTimeStamp - a.StartTimeStamp
    })
    const completedCheckPeriods = thisProcessData && thisProcessData.CompletedCheckPeriods && thisProcessData.CompletedCheckPeriods.sort((a: any, b: any) => {
        return b.StartTimeStamp - a.StartTimeStamp
    })

 

    const totalCheckPeriods = (pendingCheckPeriods && pendingCheckPeriods.length) + (completedCheckPeriods && completedCheckPeriods.length)

    if (totalCheckPeriods === 0) {
        return null
    }

    return <div className={`w-full flex-1 h-full flex flex-col items-center gap-2`}>
        {pendingCheckPeriods && pendingCheckPeriods.length > 0 && <>
        <h4 className={`text-xl font-righteous text-brandblue`}>{t('ProcessPages.ProcessSummaryCheckPeriods.checklistsToComplete')}</h4>
        <div className={`w-full flex flex-col gap-2`}>
            {pendingCheckPeriods && pendingCheckPeriods.map((thisCheckPeriod: any, index: number) => {
                const checklistId = thisCheckPeriod && thisCheckPeriod.ChecklistId
                const thisChecklist = tableData && tableData.Checklists && tableData.Checklists[checklistId]
                return <CollapsableCheckPeriodSummary
                    key={index}
                    checklistId={checklistId}
                    thisChecklist={thisChecklist}
                    checkPeriodId={thisCheckPeriod.Id}
                    thisCheckPeriod={thisCheckPeriod}
                    expandedByDefault={true}
                />
            })}
        </div>
        </>}
        {completedCheckPeriods && completedCheckPeriods.length > 0 && <div className={`w-full flex flex-col gap-2 items-center`}>
            <h4 className={`text-xl font-righteous text-brandblue`}>{t('ProcessPages.ProcessSummaryCheckPeriods.completedChecklists')}</h4>

        <div className={`w-full flex flex-col gap-2`}>
            {completedCheckPeriods.map((thisCheckPeriod: any, index: number) => {
                 const checklistId = thisCheckPeriod && thisCheckPeriod.ChecklistId
                const thisChecklist = tableData && tableData.Checklists && tableData.Checklists[checklistId]
                if (!thisChecklist){ 
                    console.error(`No checklist found for ID: ${checklistId} in completed check periods`)
                    return null 
                }
                return <CollapsableCheckPeriodSummary
                    key={index}
                    checklistId={checklistId}
                    thisChecklist={thisChecklist}
                    checkPeriodId={thisCheckPeriod.Id}
                    thisCheckPeriod={thisCheckPeriod}
                />
            })}   
        </div>
        </div>}
    </div>



}
export default ProcessSummaryCheckPeriods